import * as React from "react";
import {Route, Switch} from "react-router-dom";
import {history} from "load/store";
import RepaymentOptions from "consent/repayment/repaymentOptions";
import NachUpload from "consent/repayment/nachUpload";

export enum RepayRoutePaths {
  SCAN = "/scan",
}

export function getRepayRoute(path: string) {
  return (
    <Switch>
      <Route exact path={`${path}`} component={RepaymentOptions}/>
      <Route exact path={`${path}${RepayRoutePaths.SCAN}`} component={NachUpload}/>
    </Switch>
  );
}

export function handleRepayNavigation(navigatePath: string, state?: object) {
  const obj: any = {pathname: navigatePath};
  if (state) {
    obj.state = state;
  }
  history.push(obj);
}
